module.exports = __webpack_public_path__ + "static/media/foam-thumb.db660870.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/foam-thumb.jpg
// module id = 588
// module chunks = 0